import { jsx as _jsx } from "react/jsx-runtime";
import { TicketRedemptionCodeCategory, TicketVoucherTypePin } from '@vista/omnichannel-components-domain';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { InputField } from '../../../../subcomponents/form/field/input';
import { TicketRedemptionCodeFormContextInstance } from '../../ticket-redemption-code-form/types/context';
import { getSelectedType } from '../../ticket-redemption-code-form/utils/get-selected-type';
import { useResetField } from '../utils/use-reset-field';
export const TicketRedemptionCodeFormFieldPin = observer(props => {
    const { skeleton, fieldKey } = props;
    const { formData, codeTypes, loading, validationConfig, onChange } = useContext(TicketRedemptionCodeFormContextInstance);
    const showPin = typeSupportsPin(getSelectedType(codeTypes, formData.typeId));
    useResetField(props, showPin);
    if (!showPin)
        return null;
    if (loading)
        return skeleton;
    return (_jsx(InputField, Object.assign({}, props, { validationConfig: validationConfig.pin, value: formData.pin, type: "number", onChangeValue: newValue => onChange(fieldKey, newValue) })));
});
TicketRedemptionCodeFormFieldPin.displayName = 'TicketRedemptionCodeFormFieldPin';
const typeSupportsPin = (type) => {
    return !!type && type.category === TicketRedemptionCodeCategory.Voucher && type.pin !== TicketVoucherTypePin.None;
};
